var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-crop"},[_c('div',{staticClass:"origin-image"},[_c('img',{ref:"img",attrs:{"src":_vm.src}})]),_c('div',{staticClass:"image-preview"},[_c('div',{ref:"previewCube",staticClass:"cube"}),_c('div',{ref:"previewRound",staticClass:"round"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }